module.exports = __webpack_public_path__ + "static/media/logo1.c63b25eb.png";